import { authApi } from './authApi';

export const createLocation = async (payload: any) => {
  return await authApi.post('admin/location/', payload);
};

export const fetchLocation = async (params?: string): Promise<any> => {
  const url = params ? `admin/location/${params}` : 'admin/location/';
  return await authApi.get(url);
};

export const updateLocation = async (payload: any) => {
  return await authApi.patch(`admin/location/${payload?.id}/`, payload?.body);
};

export const bulkLocationStatus = async (payload: any) => {
  return await authApi.patch(`admin/location/status_update/`, payload);
};
